__webpack_require__.p = "/reactjs-razorpay/";